import React, { Component } from 'react';
import {
	Link
} from 'react-router-dom';

class EachFile extends Component {
    render() {
    	return(
			<div className="file anim1 br5" style={{backgroundColor: (this.props.index % 2 === 0 ? '#FAFAFA' : '#FFFFFF')}}>
				<div className="row fileRow">
					<div className="rt" style={{width: '20%', float: 'left'}}><span className="mobileShowIB"><strong>Upload Date:</strong></span> {this.props.children.dateUpload}</div>
					<div className="rt" style={{width: '25%', float: 'left'}}><span className="mobileShowIB"><strong>File Name:</strong></span> {this.props.children.name.split("_")[0].slice(0, -4)}</div>
					<div className="rt" style={{width: '15%', float: 'left'}}><span className="mobileShowIB"><strong>File Type:</strong></span> {this.props.children.type}</div>
					<div className="rt" style={{width: '15%', float: 'left'}}><span className="mobileShowIB"><strong>Is Mapped:</strong></span> {Number(this.props.children.used) === 0 ? 'No' : 'Yes'}</div>
					<div className="rt" style={{width: '25%', float: 'left'}}>
						<span className="mobileShowIB"><strong>Actions:</strong></span>
						<a target="_blank" rel="noopener noreferrer" download={this.props.children.name.split("-")[0] + this.props.children.type} className="fileLink" href={'https://api.fresenius-kabi.garritz.biz/importer/docs/csv/' + this.props.children.name}><span className="fas fa-fw fa-download"></span></a>
						{Number(this.props.children.used) === 0 ? <button className="fileLink" style={{ marginLeft: 20, marginTop: -5 }} onClick={() => this.props.deleteFile(this.props.children.id)}><span className="fas fa-fw fa-trash"></span></button> : <button className="fileLink" style={{ marginLeft: 20, marginTop: -5 }} onClick={() => this.props.deleteFileAndContents(this.props.children.id)}><span className="fas fa-fw fa-trash"></span></button>}
						{Number(this.props.children.used) === 0 ? <Link style={{ marginLeft: 20, marginTop: -4 }} className="fileLink" to={'/files/import/map/' + this.props.children.id}><span className="fas fa-fw fa-arrow-right"></span></Link> : null}
					</div>
				</div>
			</div>
    	);
    }
}

export default EachFile;


// WEBPACK FOOTER //
// ./src/components/EachFile.js